<div class="relative w-full h-screen overflow-hidden">
  <!-- Background Layer -->
  <div class="app-background absolute inset-0"></div>

  <!-- Content Layer -->
  <div class="relative w-full h-full flex" [class.p-4]="!hideDefaultLayout" [class.gap-8]="!hideDefaultLayout">
    <!-- Floating Sidebar -->
    @if (!hideDefaultLayout) {
      <div class="shrink-0">
        <app-sidebar [currentUser]="currentUser" class="block h-full"></app-sidebar>
      </div>
    }

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col min-w-0" [class.gap-[30px]]="!hideDefaultLayout">
      <!-- Floating Header -->

      @if (!hideDefaultLayout) {
        <div class="shrink-0">
          <app-header [currentUser]="currentUser"></app-header>
        </div>
      }

      <!-- Page Content -->
      <main class="flex-1 overflow-y-auto">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>

<app-modal-host></app-modal-host>
<p-toast />
